import type { IFormsDefaultValuesSettings, IGoogleSettings, ISentrySettings } from '@treneo/models';

import { useAppConfigQuery } from './app-config-query';
import * as selectors from './config-ui-selectors';
import { useConfigUiStore } from './config-ui-store';

const DEFAULT_GOOGLE_SETTINGS: IGoogleSettings = { clientId: '' };
const DEFAULT_SENTRY_SETTINGS: ISentrySettings = {};
const DEFAULT_FORMS_DEFAULT_VALUES_SETTINGS: IFormsDefaultValuesSettings = {};

export const useSelectGoogleSettings = (): IGoogleSettings =>
  useAppConfigQuery().data?.googleSettings ?? DEFAULT_GOOGLE_SETTINGS;

export const useSelectSentrySettings = (): ISentrySettings =>
  useAppConfigQuery().data?.sentrySettings ?? DEFAULT_SENTRY_SETTINGS;

export const useSelectFormsDefaultValuesSettings = (): IFormsDefaultValuesSettings =>
  useAppConfigQuery().data?.formsDefaultValuesSettings ?? DEFAULT_FORMS_DEFAULT_VALUES_SETTINGS;

export const useSelectIsConfigLoading = () => useAppConfigQuery().isLoading;

export const useSelectConfigLoadError = () => {
  const error = useAppConfigQuery().error;
  return error != null ? String(error) : null;
};

export const useSelectIsAppInitialized = () => {
  const { isLoading, error } = useAppConfigQuery();
  return !isLoading && error == null;
};

export const useSelectShouldShowExternalLoginProviders = () => {
  const googleSettings = useAppConfigQuery().data?.googleSettings;
  return !!(googleSettings?.clientId && String(googleSettings.clientId).trim() !== '');
};

export const useSelectFreshStartFormDefaultValues = () =>
  useSelectFormsDefaultValuesSettings().freshStartForm;

export const useDateTimeConfig = () => {
  const dateFormat = useConfigUiStore(selectors.selectDateTimeDateFormat);
  const timeFormat = useConfigUiStore(selectors.selectDateTimeTimeFormat);
  const displayMode = useConfigUiStore(selectors.selectDateTimeDisplayMode);
  const timeStep = useConfigUiStore(selectors.selectDateTimeTimeStep);
  const mondayFirst = useConfigUiStore(selectors.selectDateTimeMondayFirst);
  return { dateFormat, timeFormat, displayMode, timeStep, mondayFirst };
};
